import {createSelector} from 'reselect';
import {getIsMobile} from './system';
import {getTravelerSegments} from './travelerSegmentFeatures';

const MAIN_CONTENT_SECTIONS = {
    amenities: 'amenities',
    map: 'map',
    overview: 'overview',
    rates_availability: 'rates-availability',
    reviews: 'reviews'
};

const getDesktopLayout = createSelector(
    [getTravelerSegments],
    ({coldStartUser}) => {
        return {
            spacingBelow: {
                default: '32px',
                'listing-summary-desktop': '16px',
                'about-the-property': '88px',
                'inline-virtual-tour': '88px',
                'unit-spaces': '88px',
                'midpage-reco-carousel': '88px',
                'chat-ui': '88px',
                'owner-details': '88px',
                amenities: '88px'
            },
            order: [
                {
                    name: MAIN_CONTENT_SECTIONS.overview,
                    elements: [
                        'inline-urgency',
                        'listing-summary-desktop',
                        'about-the-property',
                        'inline-virtual-tour',
                        'unit-spaces',
                        coldStartUser ? 'midpage-reco-carousel' : null,
                        'chat-ui',
                        'owner-details',
                        'auth-card'
                    ]
                },
                {
                    name: MAIN_CONTENT_SECTIONS.amenities,
                    elements: ['amenities', 'house-rules']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.reviews,
                    elements: ['reviews']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.map,
                    elements: ['map']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.rates_availability,
                    elements: ['rates-availability-calendar']
                }
            ]
        };
    }
);

const getMobileLayout = createSelector(
    [getTravelerSegments],
    ({coldStartUser}) => {
        return {
            spacingBelow: {
                default: '32px',
                'listing-summary': '8px',
                'trip-details': '8px',
                'free-cancellation': '24px',
                'owner-details-mini': '16px',
                'booking-assistance': '24px',
                'listing-details': '88px',
                'chat-ui': '88px',
                'owner-details': '88px',
                'unit-spaces': '88px',
                amenities: '88px'
            },
            order: [
                {
                    name: MAIN_CONTENT_SECTIONS.overview,
                    elements: [
                        'inline-urgency',
                        'listing-summary',
                        'trip-details',
                        'free-cancellation',
                        'owner-details-mini',
                        'booking-assistance',
                        'bear-stay-banner',
                        'listing-details',
                        'civil-code-disclaimer',
                        'inline-virtual-tour',
                        coldStartUser ? 'reco-carousels' : null,
                        'chat-ui',
                        'owner-details',
                        'auth-card',
                        'unit-spaces',
                        'house-rules'
                    ]
                },
                {
                    name: MAIN_CONTENT_SECTIONS.reviews,
                    elements: ['reviews']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.map,
                    elements: ['map']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.rates_availability,
                    elements: ['rates-availability']
                },
                {
                    name: MAIN_CONTENT_SECTIONS.amenities,
                    elements: ['amenities']
                }
            ]
        };
    }
);

const getLayout = createSelector(
    [getIsMobile, getDesktopLayout, getMobileLayout],
    (isMobile, desktopLayout, mobileLayout) => {
        return isMobile ? mobileLayout : desktopLayout;
    }
);
export default getLayout;
export {getLayout, MAIN_CONTENT_SECTIONS};
